import React from "react";
import { sortBy } from "lodash";
import { Field, reduxForm } from "redux-form";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton.jsx";
import { renderField, renderSelect } from "./_fieldRenderer";
import { db } from "../services/firebase";

import "./forms.css";

class TableForm extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;
    this.state = {
      products: [],
      fetchingProducts: false,
    };
  }

  componentDidMount() {
    const products = [];
    this.setState({ fetchingProducts: true });
    db.collection("companies")
      .doc(this.props.companyID)
      .collection("products")
      .get()
      .then((productSnapshot) => {
        if (!productSnapshot.empty) {
          productSnapshot.forEach((product) =>
            products.push({
              value: product.id,
              label: `${product.data().name}`,
            })
          );
          this.setState({ fetchingProducts: false, products });
        } else {
          this.setState({ fetchingProducts: false, products });
        }
      });
  }
  render() {
    const { handleSubmit, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="name"
                type="text"
                component={renderField}
                label="Nome"
                placeholder="Nome"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="products"
                component={renderSelect}
                label="Produto"
                disabled={!this.state.products.length}
                placeholder={this._handlePlaceholder(this.state.products)(
                  this.state.fetchingProducts
                )("male")}
                options={sortBy(this.state.products, ["label", "asc"])}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="form__actions_margin">
          <div className="form__actions_container">
            <Button
              style={{ width: "45%" }}
              bsStyle="danger"
              type="button"
              disabled={submitting}
              onClick={this._handleCancel}
              wd
            >
              Cancelar
            </Button>
            <Button
              style={{ width: "45%" }}
              bsStyle="default"
              type="submit"
              disabled={submitting}
              fill
            >
              Salvar
            </Button>
          </div>
        </Row>
      </form>
    );
  }

  //handlers
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };

  _handlePlaceholder = (stateProperty) => (stateFetch) => (gender) => {
    if (stateFetch) {
      return "Aguarde";
    }

    if (!stateFetch && !stateProperty.length) {
      return `Nenhum${gender === "male" ? "" : "a"} cadastrad${
        gender === "male" ? "o" : "a"
      }`;
    }

    if (!stateFetch && stateProperty.length) {
      return "Selecione";
    }
  };
}

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Obrigatório";
  }
  if (!values.products) {
    errors.products = "Obrigatório";
  }
  return errors;
};

TableForm = reduxForm({ form: "TableForm", validate })(TableForm);
export default TableForm;



// WEBPACK FOOTER //
// ./src/forms/TableForm.jsx